import {Injectable} from '@angular/core';
import {CaseEntitiesActions, NotificationActions, WorkingGroupsActions} from "../store/actions";
import {NotificationCategoryEnum, NotificationDto, NotificationStatusEnum, NotificationTypeEnum} from "@esa/api";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _store: Store, private _router: Router) { }

  updateReadStatus(message: string, notificationType: NotificationTypeEnum, userId: string, id: string, notificationCategory: NotificationCategoryEnum, reference: string): void {
    this._store.dispatch(NotificationActions.updateNotification({
      notification: {
        id: id,
        message: message,
        notificationStatus: NotificationStatusEnum.READ,
        notificationType: notificationType,
        userId: userId,
        category: notificationCategory,
        reference: reference
      }
    }));
  }

  viewNotification(notification: NotificationDto): void {
    if(notification.category === NotificationCategoryEnum.CASE){
      if(notification.reference == null) {
        this._router.navigateByUrl('case-management');
      } else {
        this._store.dispatch((CaseEntitiesActions.setSelectedCaseEntityId({ selectedCaseEntityId: notification.reference })));
        this._store.dispatch(CaseEntitiesActions.setShowEditForm({ showEditForm: false }));
        this._router.navigateByUrl('case-management/case-details');
      }
    } else if(notification.category === NotificationCategoryEnum.USER) {
      this._router.navigateByUrl('users');
    } else {
      if(notification.reference == null) {
        this._router.navigateByUrl('working-groups/view');
      } else {
        this._store.dispatch((WorkingGroupsActions.setSelectedWorkingGroupId({ selectedWorkingGroupId: notification.reference })));
        this._store.dispatch((WorkingGroupsActions.getWorkingGroupById({ id: notification.reference })));
        this._router.navigateByUrl('working-groups/view');
      }
    }

    this.updateReadStatus(notification.message, notification.notificationType, notification.userId, notification.id, notification.category, notification.reference);
  }
}
